import React, { useEffect, useState } from "react";
import {
  Badge,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Tooltip,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ComputerIcon from "@mui/icons-material/Computer";

const ListCard = ({ workshop, select }) => {
  const userWorkshops = useSelector((state) => state.workshops.userWorkshops);

  const showMyWorkshops = useSelector(
    (state) => state.workshops.filter.myWorkshops
  );
  const [cardColor, setCardColor] = useState("item.notSelected");
  const { id } = useParams();

  const registered = userWorkshops.registrations.find(
    (w) => w.workshopId == workshop.workshopId
  );

  const waitlist = userWorkshops.waitlists.find(
    (w) => w.workshopId == workshop.workshopId
  );

  //set the selected workshop card colour
  useEffect(() => {
    workshop.workshopId === Number(id)
      ? setCardColor("item.selected")
      : setCardColor("item.notSelected");
  }, [id, showMyWorkshops, workshop.workshopId]);

  return (
    <Card sx={{ my: 0.5, backgroundColor: cardColor }} variant="outlined">
      {workshop && (
        <>
          <CardActionArea onClick={() => select(workshop.workshopId)}>
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ flexGrow: "1" }}>
                <Typography variant="h5">
                  {registered && (
                    <Tooltip
                      placement="bottom"
                      arrow
                      title="You are registered"
                    >
                      <BeenhereIcon
                        fontSize="inherit"
                        color="success"
                        sx={{ marginRight: "0.4rem" }}
                      />
                    </Tooltip>
                  )}
                  {waitlist && !waitlist?.offeredSeatDatetime && (
                    //user is on the waitlist (not offered a seat)
                    <Tooltip
                      placement="bottom"
                      arrow
                      title="You are on the waitlist"
                    >
                      <AccessTimeIcon
                        fontSize="inherit"
                        color="info"
                        sx={{ marginRight: "0.4rem" }}
                      />
                    </Tooltip>
                  )}
                  {waitlist?.offeredSeatDatetime &&
                    waitlist?.offerExpiredDatetime === null && (
                      //user is on the waitlist and is offered a seat
                      <Tooltip
                        placement="bottom"
                        arrow
                        title="You are on the waitlist and a seat is available for you!"
                      >
                        <EventSeatIcon
                          fontSize="inherit"
                          color="warning"
                          sx={{ marginRight: "0.4rem" }}
                        />
                      </Tooltip>
                    )}
                  {workshop.title}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="body2">
                    {DateTime.fromISO(workshop.startDatetime).toLocaleString(
                      DateTime.DATETIME_MED_WITH_WEEKDAY
                    )}
                    <br />
                    Registration ends:&nbsp;
                    {DateTime.fromISO(
                      workshop.registrationEndDate
                    ).toLocaleString({
                      month: "short",
                      day: "numeric",
                    })}
                  </Typography>
                  <Chip
                    label={workshop.category.name}
                    size="small"
                    sx={{ marginRight: "0.5rem" }}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {workshop.seats.emptySeats !== undefined && (
                  <Typography variant="h4">
                    <Tooltip
                      placement="right"
                      arrow
                      title={workshop.seats.emptySeats + " seats available"}
                    >
                      <Badge
                        badgeContent={
                          workshop.seats.emptySeats < 1
                            ? "full"
                            : workshop.seats.emptySeats
                        }
                        color={
                          workshop.seats.emptySeats < 1 ? "error" : "secondary"
                        }
                      >
                        <EventSeatIcon />
                      </Badge>
                    </Tooltip>
                  </Typography>
                )}
                {workshop.virtual && (
                  <Tooltip
                    title="This workshop is provided online"
                    placement="right"
                    arrow
                  >
                    <ComputerIcon color="primary" />
                  </Tooltip>
                )}
              </Box>
            </CardContent>
          </CardActionArea>
        </>
      )}
    </Card>
  );
};

export default ListCard;
